import serverApi from './nknServerApi'
import store from '../store/'

let neApiTask = function (api, paramGetter, interval, success, failed) {
  let timer = null
  let paused = true

  function _success(data) {
    if(success instanceof Function) {
      success(data)
    }

    timer = setTimeout(function() {
      callApi()
    }, interval)
  }

  function _failed(data) {
    if(failed instanceof Function) {
      failed(data)
    }

    timer = setTimeout(function() {
      callApi()
    }, interval)
  }

  function callApi() {
    if(paused) {
        return;
    }
    
    if(paramGetter instanceof Function) {
      api(paramGetter(), _success, _failed)
    } else {
      api(null, _success, _failed)
    }
  }

  function doRequest() {
    if(paramGetter instanceof Function) {
      api(paramGetter(), _success, _failed)
    } else {
      api(null, _success, _failed)
    }
  }

  return {
    isRunning: function () {
      return null !== timer
    },

    fire: function () {
      doRequest()
      return this
    },

    resume: function () {
      paused = false
      if(null === timer) {
        callApi()
      }
      return this
    },

    pause: function () {
      paused = true
      if(timer == null) {
        clearTimeout(timer)
      }
      timer = null
      return this
    },

    start: function () {
      paused = false;
      if(this.isRunning()) {
        return this
      }

      //get data at least once
      callApi()

      return this
    }
  }
}

let singletonGeoList = null;
let singletonGeoSummary = null;

const NKNTasks = {
  geoList: (singletonGeoList == null) ? singletonGeoList = (new neApiTask(serverApi.getGeoList, null, 900000, function (data) {
      console.log(new Date(), "geoList handler start");
      store.commit('map/upateGeoList', data)
      console.log(new Date(), "geoList handler end");
  })) : singletonGeoList,

  geoSummary: (singletonGeoSummary == null) ? singletonGeoSummary = (new neApiTask(serverApi.getGeoSummry, null, 900000, function (data) {
      console.log(new Date(), "geoSummary handler start");
      store.commit('map/updateSummary', data)
      console.log(new Date(), "geoSummary handler end");
  })) : singletonGeoSummary,
}

export default {
  install: function (Vue) {
    Vue.prototype.$NKNTasks = NKNTasks
  }
};


// WEBPACK FOOTER //
// ./src/tasks/nknTask.js